/* eslint-disable no-nested-ternary */
import React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import logo from '../../assets/guest-ranger-logo.svg';
import { selectCurrentCompany, selectIsPending } from '../../store/companySlice';
import { inIframe } from '../../helpers';

const useStyles = makeStyles((theme) => ({
  appbar: {
    backgroundColor: theme.palette.background.paper,
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  link: {
    display: 'flex',
  },
  logo: {
    height: '58px',
    width: 'auto',
  },
}));

export default function PublicHeader() {
  const classes = useStyles();
  const company = useSelector(selectCurrentCompany);
  const isPending = useSelector(selectIsPending);

  return (
    <>
      {!inIframe()
      && (
      <AppBar position="absolute" className={classes.appbar}>
        <Toolbar>
          {
          !isPending
            ? (company && company.companyLogo)
              ? <img className={classes.logo} src={company.companyLogo} alt={(company && company.companyName) || ''} />
              : (
                <a className={classes.link} href="https://guestranger.com/" target="_blank" rel="noreferrer">
                  <img className={classes.logo} src={logo} alt="Guest Ranger" />
                </a>
              )
            : ''
          }
        </Toolbar>
      </AppBar>
      )}
    </>
  );
}
